export default __webpack_public_path__ + "static/sung-choi-10a2222cc060cfd9c4bfd3c35891b827.jpg";